import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.pointers = new Set()
    this.pulses = new Map()
    this.pending = null
    this.listeners = {
      pointerdown: event => this.start(event),
      pointermove: event => this.move(event),
      pointerup: event => this.finish(event),
      pointercancel: event => this.cancel(event),
      scroll: () => { this.pending = null }
    }
    for (const [name, listener] of Object.entries(this.listeners)) {
      window.addEventListener(name, listener, { capture: true, passive: true })
    }
  }

  disconnect() {
    for (const [name, listener] of Object.entries(this.listeners)) {
      window.removeEventListener(name, listener, true)
    }
    for (const [pulse, timer] of this.pulses) {
      window.clearTimeout(timer)
      pulse.remove()
    }
    this.pending = null
    this.pointers.clear()
    this.pulses.clear()
  }

  start(event) {
    this.pointers.add(event.pointerId)
    if (!event.isPrimary || event.button !== 0 || this.pointers.size !== 1) {
      this.pending = null
      return
    }
    this.pending = { id: event.pointerId, x: event.clientX, y: event.clientY, time: event.timeStamp }
  }

  move(event) {
    if (this.pending?.id !== event.pointerId) return
    if (Math.hypot(event.clientX - this.pending.x, event.clientY - this.pending.y) > 10) {
      this.pending = null
    }
  }

  cancel(event) {
    this.pointers.delete(event.pointerId)
    this.pending = null
  }

  finish(event) {
    this.move(event)
    this.pointers.delete(event.pointerId)
    const tap = this.pending
    if (!tap || tap.id !== event.pointerId) return
    this.pending = null
    if (event.timeStamp - tap.time > 500) return
    this.pulse(event.clientX, event.clientY)
  }

  pulse(x, y) {
    const pulse = document.createElement("span")
    pulse.className = "tap-highlight-pulse"
    pulse.setAttribute("aria-hidden", "true")
    pulse.style.left = `${x}px`
    pulse.style.top = `${y}px`
    document.documentElement.appendChild(pulse)
    const timer = window.setTimeout(() => {
      pulse.remove()
      this.pulses.delete(pulse)
    }, 650)
    this.pulses.set(pulse, timer)
  }
}
